import Header from '@/components/Header'
import useDocumentTitle from '@/components/Helmet';
import React from 'react'

const Listing = () => {
    useDocumentTitle("Listing");
    return (
        <div>
            <Header />

            <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                <h2 className="text-2xl font-semibold mb-4 text-center text-red-600">Page Under Development</h2>
            </section>
        </div>
    )
}

export default Listing